import React from "react";
import { Form, Formik } from "formik";
import Styles from "./style.module.scss";
import { Button, TypeStyleButton } from "../Button";
import classNames from "classnames/bind";
import PreLoader from "../PreLoader/PreLoader";

export interface PropsAdminFrom {
  initialValues: {};
  validationSchema?: {};
  onSubmit: (values: any) => boolean | void | Promise<boolean | void>;
  children: React.ReactNode;
  buttonProps: { title: string; style: TypeStyleButton; editStyle?: string; edit?: boolean; onDirty?: boolean };
  styleForm?: string;
  loading?: boolean;
  error?: string;
  submitDisabled?: boolean;
}

export const FormikFormComponent: React.FC<PropsAdminFrom> = ({
  initialValues,
  validationSchema,
  onSubmit,
  children,
  buttonProps,
  styleForm,
  loading,
  submitDisabled = false,
}) => {
  const cx = classNames.bind(Styles);
  const formStyles = cx("form", `form__${styleForm}`);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, action) => {
        const submittedSuccessfully = await onSubmit(values);
        if (submittedSuccessfully !== false) {
          action.resetForm();
        }
      }}
      enableReinitialize={true}
    >
      {(props) => (
        <Form className={formStyles} onSubmit={props.handleSubmit}>
          {children}
          <div className={Styles.form__actions}>
            <Button
              styleButton={buttonProps.style}
              edit={buttonProps.edit}
              editStyle={buttonProps.editStyle}
              type="submit"
              disabled={submitDisabled || props.isSubmitting || !props.isValid || (buttonProps.onDirty && !props.dirty)}
            >
              {buttonProps.title}
            </Button>
            {loading && (
              <div className={Styles.form__sendingStatus} role="status" aria-live="polite">
                <PreLoader />
                <span>Please wait while we securely send your request.</span>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};
